import { createActions, createReducer } from 'reduxsauce';
import {
	set, cloneDeep, isUndefined, forEach,
} from 'lodash';

/* ------------- Initial State ------------- */
export const INITIAL_STATE = {};

/* ------------- Types and Action Creators ------------- */
export const { Types, Creators } = createActions({
	changeState       : ['module', 'property', 'value'],
	changeMultiStates : ['paths'],
	setRouteDetails   : ['match'],
}, { prefix : '@globals/' });

const changeState = ({
	state,
	module,
	property,
	value,
}) => {
	const newState = cloneDeep(state);

	// Only update the state if it's the same Module
	if (
		!isUndefined(module)
		&& !isUndefined(newState[module])
	) set(newState[module], property, value); // Update value

	return newState;
};

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
	[Types.CHANGE_STATE] : (state, { module, property, value }) => (
		changeState({
			state,
			module,
			property,
			value,
		})
	),

	[Types.CHANGE_MULTI_STATES] : (state, { paths }) => {
		let newState = cloneDeep(state);

		forEach(paths, ({ module, property, value }) => {
			newState = changeState({
				module,
				property,
				value,
				state : newState,
			});
		});

		return newState;
	},

	[Types.SET_ROUTE_DETAILS] : (state, { match }) => (
		changeState({
			state,
			module   : 'router',
			property : 'match',
			value    : match,
		})
	),
});

export default Creators;
